export default __webpack_public_path__ + "media/images/about/step-3.jpg";